import React from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage';

import NavListItem from './NavListItem.jsx';

const labels = {
  'zh-hant': '中文',
  en: 'English',
};

const langs = ['zh-hant', 'en'];

const LangSwitcher = () => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  const next = langs[language === langs[0] ? 1 : 0];

  return (
    <NavListItem
      icon={faLanguage}
      onClick={() => {
        i18n.changeLanguage(next);
        Cookies.set('i18next', next, {
          expires: 365,
          sameSite: 'strict',
          secure: window.location.protocol === 'https:',
        });
      }}
      label={labels[next]}
    />
  );
};

export default LangSwitcher;
